import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCQ5wn_tlgcvCsKW7R2t4CZOPfSlHhXB3k",
  authDomain: "aida-c1a69.firebaseapp.com",
  projectId: "aida-c1a69",
  storageBucket: "aida-c1a69.firebasestorage.app",
  messagingSenderId: "175082703442",
  appId: "1:175082703442:web:a15bd2ad19a7cb1e61ed8b",
};

export const firebaseApp =
  getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(firebaseApp);
